export default __webpack_public_path__ + "static/media/padelHistory.0a79ef33.jpg";